// @flow
import * as React from 'react';

import clsx from 'clsx';

import styles from './HeaderContent.scss';

export type Props = {
  children: React.Node,
};

export function HeaderContent({ children }: Props): React.MixedElement {
  return <div className={clsx(styles.root)}>{children}</div>;
}
